import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || (window.location.hostname === "localhost" ? "http://localhost:3000" : "https://api.jungleclick.online");

const socket = io(SOCKET_URL, {
    path: "/socket.io",
    transports: ["websocket"],
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: 10,
    closeOnBeforeunload: false,
    reconnectionDelay: 3000
});

export default socket;